import { dataArrowLeft } from 'dls-icons-data'
import { createIcon } from '../common'

const IconArrowLeft = /*#__PURE__*/createIcon(dataArrowLeft)
export default IconArrowLeft
